import { QuestionAnswerResponseDto } from '@families-link/shared';
import { useReactTable, getCoreRowModel } from '@tanstack/react-table';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreTable, CoreTableEmptyBody } from '../../../_core/components/_ui/core-table';
import { TableListQueryResponse } from '../../../_core/interfaces/table-list-query.interface';
import { useQuestionAnswerTableColumns } from '../../hooks/table-columns/answers-table-columns.hook';

type QuestionAnswersTableProps = TableListQueryResponse<QuestionAnswerResponseDto>;

export const QuestionAnswersTable: FC<QuestionAnswersTableProps> = (props) => {
	const { data, sorting, onSortingChange, loading, hasMore, fetchMore, scrollRef } = props;

	const [t] = useTranslation();

	const columns = useQuestionAnswerTableColumns();

	const table = useReactTable<QuestionAnswerResponseDto>({
		data,
		columns,
		state: {
			sorting,
		},
		onSortingChange,
		getCoreRowModel: getCoreRowModel(),
	});

	return (
		<CoreTable
			px={0}
			ref={scrollRef}
			loading={loading}
			hasMore={hasMore}
			threshold={200}
			emptyListComponent={
				<CoreTableEmptyBody label={t('profile.sessions.table.empty-title')} description={t('surveys.no-answers')} />
			}
			fetchMore={fetchMore}
			rowModel={table.getRowModel()}
			headerGroups={table.getHeaderGroups()}
		/>
	);
};
